
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.46.598l-.035.005c-1.138.15-1.736 1.183-1.783 1.68v1.79a28.343 28.343 0 00-1.872.02C1.276 4.255.087 5.69.039 7.115l-.015 5.052c.265 2.352 2.227 2.956 3.459 2.922-.02 1.4.887 2.289 1.853 2.302 2.336.034 5.116-.026 7.558.007 1.153-.034 1.592-1.144 1.619-2.317.495.005 1.11-.113 1.11-.113 1.99-.624 2.29-2.197 2.362-2.995.103-.702-.03-5.095-.03-5.095-.169-2.094-2.25-2.826-2.861-2.793L13.34 4.08l-.007-1.755C13.276 1.35 12.182.58 11.405.615zm.27 1.73l4.555-.001c.235.03.333.098.329.385l.001 1.341-5.276.015.03-1.425c.02-.222.063-.33.356-.318zm8.21 3.489c.466.074 1.103.376 1.251 1.093l.042 4.973c-.087.653-.215 1.378-1.723 1.488l-.007-1.36c.027-1.48-1.263-2.233-2.448-2.153L5.38 9.87c-1.517.046-1.907 1.46-1.892 1.888l-.005 1.585c-.907.049-1.463-.196-1.714-1.268l-.026-4.382c-.001-1.452.72-1.79 1.528-1.892zm-9.251 5.829l6.522-.046c.474.007.592.179.571.46l-.005 3.16c-.007.412-.168.458-.384.448l-6.88-.005a.338.338 0 01-.295-.225l.027-3.36c.007-.286-.062-.437.442-.432z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    